import { FileImage, FileText } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { fileUrl, formatSize, type FileInfo } from '@/lib/portal';
import { pdfAction } from '@/lib/pdf';
import { useOrgId } from '@/lib/org';

/** A stored file: name opens a preview in a new tab, Download saves it. */
export function FileLink({ file, showSize = true }: { file: FileInfo; showSize?: boolean }) {
  const orgId = useOrgId();
  if (!orgId) return null;
  const Icon = file.contentType === 'application/pdf' ? FileText : FileImage;
  return (
    <span className="inline-flex min-w-0 flex-wrap items-center gap-x-1 text-sm">
      <Icon className="size-4 shrink-0 text-muted-foreground" aria-hidden />
      <button
        type="button"
        className="min-w-0 text-left [overflow-wrap:anywhere] font-medium text-primary hover:underline"
        onClick={() => void pdfAction('preview', fileUrl(orgId, file.id), file.fileName)}
      >
        {file.fileName}
      </button>
      {showSize ? (
        <span className="shrink-0 text-xs text-muted-foreground">{formatSize(file.sizeBytes)}</span>
      ) : null}
      <Button
        variant="link"
        size="sm"
        className="h-auto shrink-0 px-1 text-muted-foreground"
        onClick={() => void pdfAction('download', fileUrl(orgId, file.id, true), file.fileName)}
      >
        Download
      </Button>
    </span>
  );
}
